import {
  Activity,
  Bot,
  BookOpenText,
  BrainCircuit,
  FileStack,
  FileText,
  Layers3,
  LayoutDashboard,
  MessageSquareWarning,
  MessageSquareText,
  Newspaper,
  Radio,
  ShieldCheck,
  TerminalSquare,
  Users,
} from "lucide-react";

export const adminNavigationItems = [
  {
    href: "/dashboard/admin",
    label: "Command",
    icon: BrainCircuit,
    match: (location) => location.pathname === "/dashboard/admin",
  },
  {
    href: "/dashboard/admin/assessment-ops",
    label: "Assessment",
    icon: FileStack,
    match: (location) => location.pathname === "/dashboard/admin/assessment-ops",
  },
  {
    href: "/dashboard/admin/users",
    label: "Users",
    icon: Users,
    match: (location) =>
      location.pathname === "/dashboard/admin/users" ||
      location.pathname === "/dashboard/users",
  },
  {
    href: "/dashboard/security",
    label: "Security",
    icon: ShieldCheck,
    match: (location) => location.pathname === "/dashboard/security",
  },
  {
    href: "/dashboard/systemstatus",
    label: "System",
    icon: Activity,
    match: (location) => location.pathname === "/dashboard/systemstatus",
  },
  {
    href: "/dashboard/newsticker",
    label: "Ticker",
    icon: Radio,
    match: (location) => location.pathname === "/dashboard/newsticker",
  },
  {
    href: "/dashboard/chatbot-admin",
    label: "Chatbot",
    icon: MessageSquareText,
    match: (location) => location.pathname === "/dashboard/chatbot-admin",
  },
  {
    href: "/dashboard/gpt",
    label: "GPT",
    icon: Bot,
    match: (location) =>
      location.pathname === "/dashboard/gpt" ||
      location.pathname === "/dashboard/gpt-maintainer" ||
      location.pathname === "/dashboard/gpt-docagent",
  },
];

export const adminNavigationSections = [
  {
    key: "operations",
    label: "Operations",
    items: [
      adminNavigationItems[0],
      adminNavigationItems[1],
      {
        href: "/dashboard/admin/trust-fraud",
        label: "Trust & Fraud",
        icon: ShieldCheck,
        match: (location) => location.pathname === "/dashboard/admin/trust-fraud",
      },
      {
        href: "/dashboard/admin/wissenstest",
        label: "Wissenstest",
        icon: LayoutDashboard,
        match: (location) => location.pathname === "/dashboard/admin/wissenstest",
      },
      {
        href: "/dashboard/admin/wissenstest-management",
        label: "WT Mgmt",
        icon: FileText,
        match: (location) => location.pathname === "/dashboard/admin/wissenstest-management",
      },
      adminNavigationItems[2],
      {
        href: "/dashboard/admin/kvp",
        label: "KVP",
        icon: MessageSquareWarning,
        match: (location) => location.pathname === "/dashboard/admin/kvp",
      },
      adminNavigationItems[3],
    ],
  },
  {
    key: "systems",
    label: "Systems",
    items: [
      adminNavigationItems[4],
      adminNavigationItems[5],
      {
        href: "/dashboard/nachrichten",
        label: "Nachrichten",
        icon: Newspaper,
        match: (location) => location.pathname === "/dashboard/nachrichten",
      },
      adminNavigationItems[6],
      {
        href: "/dashboard/faq-admin",
        label: "FAQ",
        icon: BookOpenText,
        match: (location) => location.pathname === "/dashboard/faq-admin",
      },
      {
        href: "/dashboard/blog",
        label: "Blog",
        icon: Newspaper,
        match: (location) =>
          location.pathname === "/dashboard/blog" ||
          location.pathname.startsWith("/dashboard/blog-editor/"),
      },
      {
        href: "/dashboard/admin/coreui-pro-showcase",
        label: "CoreUI PRO",
        icon: Layers3,
        match: (location) => location.pathname === "/dashboard/admin/coreui-pro-showcase",
      },
    ],
  },
  {
    key: "ai",
    label: "AI",
    items: [
      adminNavigationItems[7],
      {
        href: "/dashboard/gpt-maintainer",
        label: "Maintainer",
        icon: Bot,
        match: (location) => location.pathname === "/dashboard/gpt-maintainer",
      },
      {
        href: "/dashboard/gpt-docagent",
        label: "DocAgent",
        icon: Bot,
        match: (location) => location.pathname === "/dashboard/gpt-docagent",
      },
      {
        href: "/admin/gpt-terminal",
        label: "Terminal",
        icon: TerminalSquare,
        match: (location) => location.pathname === "/admin/gpt-terminal",
      },
    ],
  },
];

export function flattenAdminNavigationSections(sections = adminNavigationSections) {
  return sections.flatMap((section) => section.items || []);
}
